export default "__VITE_ASSET__CHTHECdb__"